import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

import { Dropdown } from "@/src/component/base/Dropdown";
import { GROWTHBOOK_URL } from "@/src/const";
import VariantTestingLogic from "@/src/logic/VariantTestingLogic";
import { GrowthBookType } from "@/src/type/growthbook";

import styles from "./ExperimentDropdown.module.scss";

interface ExperimentDropdownProps {
  growthBook: GrowthBookType.GrowthBookAndContentVariants;
}

function ExperimentDropdown({ growthBook }: ExperimentDropdownProps) {
  const experiments = VariantTestingLogic.getExperiments(growthBook ?? {});
  const options = Object.entries(experiments).map(([key, value]) => ({
    label: value.name,
    value: key,
  }));

  function openGrowthbook() {
    window.open(`${GROWTHBOOK_URL}/experiments`, "_growthbook");
  }

  return (
    <>
      <div className={styles.titleContainer}>
        <Typography
          variant="h5"
          fontFamily="var(--roughwell)"
          lineHeight="100%"
        >
          Experiments
        </Typography>
        <IconButton
          color="primary"
          onClick={openGrowthbook}
        >
          <AddIcon />
        </IconButton>
      </div>
      <Dropdown
        options={options ?? []}
        value={options?.[0]?.value ?? ""}
        onChange={() => {}}
        id="experiments"
        placeholder="Select an experiment"
      />
    </>
  );
}

export default ExperimentDropdown;
